<div class="field-contact-wrapper">
  <div class="contact-name" *ngFor="let contact of contacts">
    {{contact.name}}
  </div>
  <div class="contact-input" *ngIf="isInput">
    <button class="btn tn-button-primary" (click)="openContactPicker()">
      <i class="fa fa-fw fa-plus"></i>
    </button>
  </div>
</div>